module.exports = __webpack_public_path__ + "static/media/Kcumen.ba28b720.svg";